import { Card } from 'antd';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';

const CardTitle = styled(Card)`
color: 
	border-radius: 4px;
	margin-bottom: ${(props) => (props?.marginbottom > 0 ? `${props.marginbottom}px` : '0')};
	> .ant-card-body {
		display: flex;
		padding: 16px;
		align-items: center;
		:before {
			height: calc(100% - 22px);
			background: ${(props) => (props.colorname ? props.colorname : `#${props.colorcode}`)};
			width: 2px;
			border-radius: 2px;
			position: absolute;
			left: -1px;
			top: 12px;
		}
		.imageIcon {
			width: 24px;
			height: 24px;
			margin-right: 12px;
			> span {
				width: 18px;
				height: 24px;
			}
		}
		.infoText {
			min-width: 90px;
			color: ${(props) => (props.colorname ? props.colorname : `#${props.colorcode}`)};
			padding-right: 6px;
		}
	}
`;

export default function InfoMessage({
	infocontent = null,
	colorname = null,
	showicon = null,
	colorcode = '6e57f9',
	content = 'No Data',
	marginbottom = 16,
}) {
	return (
		<CardTitle
			infocontent={infocontent}
			colorname={colorname}
			showicon={showicon}
			marginbottom={marginbottom}
			colorcode={colorcode}
		>
			{showicon && <span className="imageIcon">{showicon}</span>}
			{infocontent && <span className="infoText">{infocontent} : </span>}
			{content}
		</CardTitle>
	);
}

InfoMessage.propTypes = {
	infocontent: PropTypes.string,
	colorcode: PropTypes.string,
	showicon: PropTypes.any,
	content: PropTypes.string,
	colorname: PropTypes.string,
	marginbottom: PropTypes.number,
};
